exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/stranka/FrontOffice/src/app/theme/components/baMenu/baMenu.scss
// module id = ../../../../../src/app/theme/components/baMenu/baMenu.scss
// module chunks = main